import { Controller } from "@hotwired/stimulus";

const drawerOptions = {
  placement: "right",
  backdrop: false,
  bodyScrolling: false,
  edge: false,
  onHide: () => {},
  onShow: () => {},
  onToggle: () => {},
};

const drawerInstanceOptions = {
  id: "fund-drawer",
  override: true,
};

export default class extends Controller {
  static targets = [];

  fundDrawer;
  tableReady = false;

  connect() {
    const drawerElement = document.getElementById("fund-drawer");
    if (drawerElement && window.Drawer) {
      drawerElement.classList.remove("hidden");

      this.fundDrawer = new Drawer(
        drawerElement,
        drawerOptions,
        drawerInstanceOptions
      );
      this.fundDrawer.hide();
    }

    this.updateButtonTooltip("Loading...");

    document.addEventListener("turbo:frame-load", (event) => {
      if (event.target.id === "funds_data") {
        this.waitForTableRendering();
      }
    });
  }

  waitForTableRendering() {
    let attempts = 0;
    const maxAttempts = 100;

    const checkTableRendering = () => {
      attempts++;

      const frameContent = document.getElementById("funds_data");
      const loadingText = frameContent?.querySelector("p.text-neutral-500");
      const loadingContainer = frameContent?.querySelector(
        ".flex.flex-col.items-center.justify-start.space-y-4.p-8.min-h-\\[500px\\]"
      );

      const tableElement = document.getElementById("fund-table");
      const tableController = document.querySelector(
        '[data-controller*="pages--fund--fund-table"]'
      );

      const loadingGone = !loadingText && !loadingContainer;
      const tableExists = tableElement && tableController;

      if (loadingGone && tableExists) {
        this.tableReady = true;
        this.updateButtonTooltip("Filters");
      } else if (attempts >= maxAttempts) {
        this.tableReady = true;
        this.updateButtonTooltip("Filters");
      } else {
        setTimeout(checkTableRendering, 100);
      }
    };

    checkTableRendering();
  }

  openFiltersDrawer() {
    if (!this.tableReady) {
      return;
    }

    this.fundDrawer.show();

    setTimeout(() => {
      document.dispatchEvent(new CustomEvent("fund-drawer-opened"));
    }, 100);
  }

  closeFiltersDrawer() {
    this.fundDrawer.hide();
  }

  // Dispatches a custom event so the fund-table controller (inside the turbo frame)
  // can handle the reset, since Stimulus cannot target it from the drawer button.
  resetAllFilters() {
    document.dispatchEvent(new CustomEvent("fund-reset-filters", { bubbles: true }));
  }

  updateButtonTooltip(tooltip) {
    const drawerButton = document.querySelector(
      '[data-action*="openFiltersDrawer"]'
    );
    if (drawerButton) {
      drawerButton.title = tooltip;

      const tooltipTarget = drawerButton.getAttribute("data-tooltip-target");
      if (tooltipTarget) {
        const tooltipDiv = document.getElementById(tooltipTarget);
        if (tooltipDiv) {
          const tooltipText = tooltipDiv.querySelector(
            ".tooltip-arrow"
          )?.previousSibling;
          if (tooltipText && tooltipText.nodeType === Node.TEXT_NODE) {
            tooltipText.textContent = tooltip;
          } else {
            const textNodes = Array.from(tooltipDiv.childNodes).filter(
              (node) => node.nodeType === Node.TEXT_NODE
            );
            if (textNodes.length > 0) {
              textNodes[0].textContent = tooltip;
            }
          }
        }
      }

      if (tooltip === "Loading...") {
        drawerButton.classList.add("opacity-50");
        const icon = drawerButton.querySelector("i");
        if (icon) {
          icon.classList.add("animate-pulse");
        }
      } else {
        drawerButton.classList.remove("opacity-50");
        const icon = drawerButton.querySelector("i");
        if (icon) {
          icon.classList.remove("animate-pulse");
        }
      }
    }
  }
}
